import React from "react";

/**
 * รายละเอียดห้องในการ์ดหน้ารวม
 *
 * ถ้าแอดมินจัดแต่งไว้ (room_detail_th/en จาก editor ใน CMS) ให้แสดงอันนั้น
 * ถ้ายังไม่ได้ทำ ตกกลับไปใช้ข้อความล้วนของเดิม -- ไม่แสดงทั้งคู่
 * เพราะสองอันนี้คือเนื้อหาเดียวกัน ถ้าโชว์คู่กันจะได้ข้อความซ้ำสองรอบในการ์ดเดียว
 *
 * HTML มาจาก editor ของแอดมินเท่านั้น (ระดับความเชื่อถือเดียวกับ payment_info / policy
 * ที่เว็บ render ด้วยวิธีนี้อยู่แล้ว) ไม่ได้รับ input จากผู้ใช้ทั่วไป
 */
const RoomCardDetail = ({ html = '', text = '', className = '' }) => {
  if (html) {
    return <div className={`room-rich-detail ${className}`} dangerouslySetInnerHTML={{ __html: html }} />
  }

  if (!text) {
    return null
  }

  return (
    <span className={className}>
      <a href="#">{text}</a>
    </span>
  )
}

export default RoomCardDetail;
